import React from "react";
import { Link as LinkRR } from 'react-router-dom';
import { Button, Link } from '@heroui/react';

import LayoutType         from 'src/shared/utils/layout_type';

const MenuBomTool = ({ reloadDocument }) => (
  <Link reloadDocument={reloadDocument} to="/">
    <span style={{ marginLeft: '4px' }}>BOM Tool</span>
  </Link>
)

const Footer = ({layoutType}) => {

  const reloadFrontLink = layoutType !== LayoutType.FRONT_SITE;

  return (
    <footer className="app-footer">
      <div>
        <div className="text-center">
          <div className="flex flex-col md:flex-row place-content-center items-center flex-column flex-md-row align-items-center justify-content-center">
            <span>Your opinion is important to us</span>
            <Button as={Link} href="mailto:support@emsadmin.com" color="white" variant="ghost" className="text-white mt-4 md:mt-0 md:ml-2">
              Feedback
            </Button>
          </div>
          <div className="info-links-wrap">
            <ul className="flex place-content-center gap-2 mb-3 info-links ">
              <li className="list-inline-item info-link">
                <LinkRR to="/contact-us" reloadDocument={reloadFrontLink}>
                  <span>Contact Us</span>
                </LinkRR>
              </li>
              <li className="list-inline-item info-link">
                <LinkRR reloadDocument={reloadFrontLink} to="/terms-and-conditions">
                  <span>Terms and Conditions</span>
                </LinkRR>
                <a href="#"></a>
              </li>
              <li className="list-inline-item info-link">
                <LinkRR reloadDocument={reloadFrontLink} to="/privacy-policy">
                  <span>Privacy Policy</span>
                </LinkRR>
              </li>
            </ul>
          </div>
          <div className="copyrights">
            © {new Date().getFullYear()} EMS Admin. All Rigths reserved.
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer;